<template>
  <div>
    <SpFilterForm :model="formData" @onSearch="onSearch" @onReset="onReset">
      <SpFilterFormItem prop="start_date">
        <el-date-picker
          v-model="marketing_time"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          type="datetimerange"
          range-separator="至"
          value-format="timestamp"
          :default-time="['00:00:00', '23:59:59']"
        />
      </SpFilterFormItem>

      <SpFilterFormItem prop="shop_id">
        <el-button class="btn_input" @click="onDialog('shop')">{{ shop_num }} <i
          class="el-icon-circle-plus icon"></i></el-button>
      </SpFilterFormItem>
      <SpFilterFormItem prop="shop_id">
        <el-button type="primary" @click="handleExport">导出记录</el-button>
      </SpFilterFormItem>
    </SpFilterForm>

    <el-tabs v-model="formData.behavior_type" @tab-click="handleClick">
      <el-tab-pane v-for="item in tabsList" :key="item.name" :label="item.label" :name="item.name"></el-tab-pane>
    </el-tabs>

    <SpFinder no-selection ref="finder" :setting="setting" row-actions-width="200" :row-actions-align="'left'"
      :fixed-row-action="true" :url="url" :split-count="4" :hooks="{ beforeSearch: beforeSearch }" />

      <DistributorSelect :store-visible="distributorVisible" :is-valid="true" :relDataIds="distributor_info"
        :get-status="setDistributorStatus" @chooseStore="chooseDistributorAction" @closeStoreDialog="closeDialogAction"
        returnType="selectRow"></DistributorSelect>
  </div>
</template>

<script>
const RECORD_TYPE = {
  'scan_code': {
    label: '扫码记录',
    name: 'scan_code'
  },
  'receive': {
    label: '领取记录',
    name: 'receive'
  },
  'reserve': {
    label: '预约记录',
    name: 'reserve'
  },
  'private_course_browse': {
    label: '私教浏览记录',
    name: 'private_course_browse'
  },
  'device_setup_verification': {
    label: '新机设置核销记录',
    name: 'device_setup_verification'
  },
  'device_setup_review': {
    label: '新机设置评价记录',
    name: 'device_setup_review'
  }
}

import Vue from 'vue'
import { createSetting, useDialog } from '@shopex/finder'
import DistributorSelect from '@/components/function/distributorSelect'
import { exportActivityRecord } from '@/api/member'

export default {
  components: { DistributorSelect },
  data() {
    return {
      tabsList: [
        ...Object.values(RECORD_TYPE)
      ],
      formData: {
        behavior_type: 'scan_code',
        shop_code: '',
      },
      shop_num: '归属店铺',
      marketing_time: [],
      distributorVisible: false,
      distributor_info: [],
      setDistributorStatus: false,
      lastSearchParams: {}, // 保存最后的搜索参数
    }
  },
  computed: {
    url() {
      return `/member/activity/record/list`
    },
    setting() {
      return createSetting({
        columns: this.getColumns()
      })
    },
  },
  methods: {
    getColumns() {
      const commonColumns = [
        { name: '用户ID', key: 'dummy_id' },
        {
          name: '是否会员',
          key: 'is_member',
          width: 80,
          render: (h, { row }) => {
            return (
              <div style='color: #176721;'>{row.is_member == '1' ? '是' : '否'}</div>
            )
          }
        },
        { name: '手机号', key: 'encrypted_mobile', width: 150, },
      ]

      // 根据不同的记录类型返回不同的列配置
      switch (this.formData.behavior_type) {
        case 'scan_code':
        case 'receive':
        case 'private_course_browse':
          // 扫码记录/领取记录/私教浏览记录：用户ID、是否会员、手机号、来源门店、来源门店 Apple ID、记录时间
          return [
            ...commonColumns,
            {
              name: '来源门店',
              key: 'shop_name',
              render: (h, { row }) => {
                return <div>{row.shop_name || ''}</div>
              }
            },
            {
              name: '来源门店 Apple ID',
              key: 'shop_code',
              render: (h, { row }) => {
                return <div>{row.shop_code || ''}</div>
              }
            },
            {
              name: '记录时间',
              key: 'created',
              render: (h, { row }) => {
                return (
                  <div>{this.$options.filters['datetime'].call(this, row.created, 'yyyy-MM-dd hh:mm:ss')}</div>
                )
              }
            }
          ]
        case 'reserve':
          // 预约记录：用户ID、是否会员、手机号、预约内容、来源门店、来源门店 Apple ID、记录时间
          return [
            ...commonColumns,
            {
              name: '预约内容',
              key: 'appointment_content',
              render: (h, { row }) => {
                // 根据 behavior_type 区分预约类型
                let content = row.appointment_content || ''
                if (row.behavior_type === 'reserve_private_course') {
                  return <div>私教课程</div>
                } else if (row.behavior_type === 'reserve_device_setup') {
                  return <div>新机设置</div>
                }
              }
            },
            {
              name: '来源门店',
              key: 'shop_name',
              render: (h, { row }) => {
                return <div>{row.shop_name || ''}</div>
              }
            },
            {
              name: '来源门店 Apple ID',
              key: 'shop_code',
              render: (h, { row }) => {
                return <div>{row.shop_code || ''}</div>
              }
            },
            {
              name: '记录时间',
              key: 'created',
              render: (h, { row }) => {
                return (
                  <div>{this.$options.filters['datetime'].call(this, row.created, 'yyyy-MM-dd hh:mm:ss')}</div>
                )
              }
            }
          ]
        case 'device_setup_verification':
        case 'device_setup_review':
          // 新机设置核销记录/新机设置评价记录：用户ID、是否会员、手机号、核销门店省市、核销门店、核销门店 Apple ID、来源门店、来源门店 Apple ID、记录时间
          return [
            ...commonColumns,
            {
              name: '核销门店省市',
              key: 'verify_shop_city',
              render: (h, { row }) => {
                let extra_data = {}
                try {
                  extra_data = JSON.parse(row.extra_data) || {}
                } catch (e) {
                  extra_data = {}
                }
                const address = [extra_data.province, extra_data.city, extra_data.district].filter(Boolean).join('')
                return <div>{address}</div>
              }
            },
            {
              name: '核销门店',
              key: 'verify_shop',
              render: (h, { row }) => {
                let extra_data = {}
                try {
                  extra_data = JSON.parse(row.extra_data) || {}
                } catch (e) {
                  extra_data = {}
                }
                return <div>{extra_data.shop_name || ''}</div>
              }
            },
            {
              name: '核销门店 Apple ID',
              key: 'verify_shop_apple_id',
              render: (h, { row }) => {
                let extra_data = {}
                try {
                  extra_data = JSON.parse(row.extra_data) || {}
                } catch (e) {
                  extra_data = {}
                }
                return <div>{extra_data.shop_code || ''}</div>
              }
            },
            {
              name: '来源门店',
              key: 'shop_name',
              render: (h, { row }) => {
                return <div>{row.shop_name || ''}</div>
              }
            },
            {
              name: '来源门店 Apple ID',
              key: 'shop_code',
              render: (h, { row }) => {
                return <div>{row.shop_code || ''}</div>
              }
            },
            {
              name: '记录时间',
              key: 'created',
              render: (h, { row }) => {
                return (
                  <div>{this.$options.filters['datetime'].call(this, row.created, 'yyyy-MM-dd hh:mm:ss')}</div>
                )
              }
            }
          ]
        default:
          return commonColumns
      }
    },
    onSearch() {
      this.$refs.finder.refresh(true)
    },
    onReset() {
      this.formData = {
        behavior_type: 'scan_code',
        shop_code: '',
      }
      this.marketing_time = []
      this.shop_num = '归属店铺'
      this.distributor_info = []
      this.onSearch()
    },
    beforeSearch(param) {
      let params = {
        ...this.formData,
        ...param,
        page_size: param.pageSize
      }
      // 将 marketing_time 数组拆分为 start_time 和 end_time，并将毫秒转换为秒
      if (this.marketing_time && this.marketing_time.length === 2) {
        params.start_time = Math.floor(this.marketing_time[0] / 1000)
        params.end_time = Math.floor(this.marketing_time[1] / 1000)
      }
      // 保存搜索参数供导出使用
      this.lastSearchParams = params
      return params
    },
    handleClick(tab, event) {
      this.onSearch()
    },
    handleExport() {
      // 使用保存的搜索参数（包含分页参数）
      const params = {
        ...this.lastSearchParams
      }

      exportActivityRecord(params).then(res => {
        const success = res.data.data.success
        if (success) {
          this.$message.success('导出记录已提交，请稍后在设置-导出列表中下载')
        } else {
          this.$message.error(res.data.data.message || '导出失败，请重试')
        }
      })
    },
    onDialog(type) {
      if (type === 'shop') {
        this.distributorVisible = true
      }
    },
    // 返回已选择的片铺列表
    chooseDistributorAction(val) {
      this.distributor_info = val
      let arr = []
      val.forEach(i => {
        arr.push(i.shop_code)
      });
      this.formData.shop_code = arr.join(',')
      if (val.length > 0) {
        this.shop_num = `已选择${val.length}门店`
      } else {
        this.shop_num = '归属店铺'
      }
      this.closeDialogAction()
    },
    // 关闭店铺和经销商弹窗
    closeDialogAction() {
      this.distributorVisible = false
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
